import { Injectable } from '@angular/core';

import { FirebazeStorageService } from './firebazeStorage.service';
import type { TRegionDocument, TZipcode } from '@shared/models';
// import { timeStamp } from 'console';

@Injectable({
    'providedIn': 'root'
})
export class ZipcodesService {
    private regionCode = '';
    private regionInfo!: TRegionDocument;        // TZipcodes;
    private regionDocument!: TRegionDocument;

    constructor(private firebazeStorageService: FirebazeStorageService) {
    }

    // was called getZipInfoByStateAndZipcode
    public async getStateAndZipcodeInfo(regionCode: string, zipcode: string): Promise<unknown> {
        // const sxtateInfo: TZipcodes = await this.firebazeStorageService.getStateDocument(regionCode);
        await this.cacheZipcodesByRegion(regionCode);
        const zipInfo = this.regionInfo.zipcodes.find((zip) => (zip.zipcode === zipcode));

        return { 'regionInfo': this.regionInfo, 'zipInfo': zipInfo };
    }

    // TODO: Make certain this method is called on startup
    // TODO: Rename firebazeStorageService.getStateDocument to firebazeStorageService.getRegionDocument
    public async cacheZipcodesByRegion(regionCode: string): Promise<void> {
        if (regionCode !== this.regionCode) {
            this.regionCode = regionCode;
            // TODO: Rename the storage documents from 'states' to 'regions
            this.regionDocument = await this.firebazeStorageService.getRegionDocument(regionCode);
        }
    }

    // was called getZipInfoByStateAndZipcode
    // public async getRegionAndZipcodeInfo(regionCode: string, zipcode: string): Promise<TRegionZipcodeInfo> {
    // public async getRegionAndZipcodeInfo(regionCode: string, zipcode: string): Promise<void> {

    //     console.log(zipcode);
    //     await this.cacheZipcodesByRegion(regionCode);
    //     const zipInfo = this.regionDocument.zipcodes.find(zip => {
    //         return (zip.zipcode === zipcode);
    //     });

    //     const info: TRegionZipcodeInfo = {
    //         'regionInfo': this.regionInfo,
    //         'zipInfo': zipInfo
    //     };
    //     // return {'regionInfo': this.regionInfo, 'zipInfo': zipInfo};
    //     return info;
    // }

    public getZipcodeInfo(zipcode: string): TZipcode | undefined {
        const zipInfo: TZipcode | undefined = this.regionDocument.zipcodes.find((zip) => (zip.zipcode === zipcode));

        return zipInfo;
    }

    public getRegionDocument(): TRegionDocument {
        return this.regionDocument;
    }

    //     const zipInfo = allZipcodes.zipcodes.find(zip => {
    //     return zipInfo;
    // }
}
